import styled from 'styled-components';
import variables from '../../../styles/variables';

export const Banner = styled.p`
  position: absolute;
  top: -0.8em;
  left: 1em;
  padding: 0.25em 0.5em;
  border-radius: 0.25em;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  color: ${variables.colorWhite};
  background-color: ${variables.colorRed};
`;

export const Description = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
`;

export const Title = styled.p`
  width: 100%;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  text-transform: uppercase;
  color: ${variables.colorRed};
  margin-bottom: 2px;
`;

export const Text = styled.li`
  width: 100%;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  font-weight: 500;
  margin-bottom: 0;
`;
